/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { toJS, reaction } from 'mobx';
import {
  Dropdown, Label, Icon, Popup, Menu
} from 'semantic-ui-react';
import Draggable from 'react-draggable';
import { createSearchParams } from 'react-router-dom';
import { Droppable } from 'react-beautiful-dnd';
import cx from 'classnames';
import './ContentsHeader.css';
import searchIcon from '../../images/components/contnets_header/searchIcon.png';
import filterIcon from '../../images/components/contnets_header/filter icon.png';
import closeBtn from '../../images/components/content_project_card/close_button.svg';
import deleteIcon from '../../images/components/contnets_header/delete-icon-red.svg';
import ClarityReport from '../Extensions/ClarityReport';
import copyIcon from '../../images/components/contnets_header/combined-shape-copy.svg';
import { currentSortColum } from './DropdownSortValue';
import LinkHeader from './LinkHeader';
import CommonFilterList from './CommonFilterList';

class ContentsHeaderWithResultAll extends Component {
  constructor(props) {
    super(props);
    this.toggleBtnMenuRef = React.createRef();
    this.dateRangeInputRef = React.createRef();
    this.disposers = [];
    this.state = {
      visible: false,
      rangeValue: { min: 1, max: 100 },
      checkValue: [],
      datesRange: '',
      errSearch: false,
      isDragging: false,
      isDisableStatus: false,
      sortColumn: props.sortColumn,
      radioValue: props.radioValue,
      isOpenCompare: props.isOpenCompare,
      isSetLeft: props.isSetLeft,
      isSetRight: props.isSetRight,
      viewMode: props.viewMode,
      pageSize: props.pageSize,
      isSelectable: props.isSelectable,
      isCheckAll: props.isCheckAll,
      isResizeHeaeder: props.isResizeHeaeder,
      isRendering: props.isRendering,
      isRenderListOnly: props.isRenderListOnly,
      isRenderProjectView: props.isRenderProjectView,
      refElement: props.refElement,
      popupStatus: {
        precisionLevel: false,
      },
      queryString: '',
      currentPrecisionLevel: '',
      isShowPrecisionLevelMenu: false,
    };
    this.clearSearch = this.clearSearch.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.createElementWithCanvas = this.createElementWithCanvas.bind(this);
    this.generatePdfCallback = this.generatePdfCallback.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleAssignIssue = this.handleAssignIssue.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleCompareChange = this.handleCompareChange.bind(this);
    this.handleDeleteChange = this.handleDeleteChange.bind(this);
    this.handleDateRange = this.handleDateRange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.handleSortingChange = this.handleSortingChange.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handlePrecisionLevel = this.handlePrecisionLevel.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.removeCurrentFile = this.removeCurrentFile.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleViewMode = this.toggleViewMode.bind(this);
    this.toggleSelectMode = this.toggleSelectMode.bind(this);
    this.toggleCheckChange = this.toggleCheckChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleStart = this.handleStart.bind(this);
    this.handleStop = this.handleStop.bind(this);
  }

  componentDidMount() {
    const { filter } = this.props;
    document.addEventListener('mousedown', this.handleClickOutside);

    if (filter) {
      this.updateStateFromFilter(filter);
    }

    this.getPrecisionLevel();
  }

  componentDidUpdate(prevProps) {
    const {
      queryString,
    } = this.state;
    const {
      radioValue,
      filter,
      isResizeHeaeder,
      isSetLeft,
      isSetRight,
      isOpenCompare,
      viewMode,
      pageSize,
      isSelectable,
      sortColumn,
      isCheckAll,
      refElement,
      isRendering,
      isRenderListOnly,
      isRenderProjectView,
      location,
      navigate,
      state,
    } = this.props;
    const pathname = location.pathname ? location.pathname : location;
    const isFilterChanged = JSON.stringify(prevProps.filter) !== JSON.stringify(filter);

    if (prevProps.radioValue !== radioValue) {
      if (radioValue !== 'udtime_cr' && radioValue !== 'dttime_cr') {
        this.setState({
          radioValue,
          datesRange: '',
        });
      } else {
        this.setState({
          radioValue,
        });
      }
    }

    if (prevProps.isResizeHeaeder !== isResizeHeaeder) {
      this.setState({
        isResizeHeaeder,
      });
    }

    if (prevProps.isSetLeft !== isSetLeft) {
      this.setState({
        isSetLeft,
      });
    }
    if (prevProps.isSetRight !== isSetRight) {
      this.setState({
        isSetRight,
      });
    }

    if (prevProps.isOpenCompare !== isOpenCompare) {
      this.setState({
        isOpenCompare,
      });
    }

    if (prevProps.viewMode !== viewMode) {
      this.setState({
        viewMode,
      });
    }
    if (prevProps.pageSize !== pageSize) {
      this.setState({
        pageSize,
      });
    }
    if (prevProps.isSelectable !== isSelectable) {
      this.setState({
        isSelectable,
      });
    }
    if (prevProps.sortColumn !== sortColumn) {
      this.setState({
        sortColumn,
      });
    }
    if (prevProps.isCheckAll !== isCheckAll) {
      this.setState({
        isCheckAll,
      });
    }
    if (prevProps.refElement !== refElement) {
      this.setState({
        refElement,
      });
    }

    if (prevProps.isRendering !== isRendering) {
      this.setState({
        isRendering,
      });
    }

    if (prevProps.isRenderListOnly !== isRenderListOnly) {
      this.setState({
        isRenderListOnly,
      });
    }

    if (prevProps.isRenderProjectView !== isRenderProjectView) {
      this.setState({
        isRenderProjectView,
      });
    }

    if (isFilterChanged && filter) {
      this.updateStateFromFilter(filter);
    }

    if (location.search !== queryString && (pathname !== '/results/overview/' && pathname !== '/results/overview' && !pathname.includes('project'))) {
      this.setState({
        queryString: location.search,
      }, () => {
        if (state.pages.isSelecatbleWithNavibar) {
          const URLparams = toJS(state.pages.selectedIndexWithNavibar);
          navigate({
            pathname: '/results/overview',
            search: createSearchParams({
              project: URLparams.project,
              project_version: URLparams.project_version,
            }).toString()
          });
        } else {
          navigate(`/results/overview${location.search}`);
        }
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    this.disposers.forEach((disposer) => {
      disposer();
    });
  }

  handleSearchChange(event) {
    const { handleSearchChange } = this.props;
    handleSearchChange(event.target.value);
  }

  handleSearch(event) {
    const { onChangeSearch } = this.props;
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
              });
            }, 1500);
          }
        );
        return false;
      }
      onChangeSearch(event.target.value);
    }
  }

  handlePopupOpen() {
    const status = {
      precisionLevel: true,
    };

    this.setState({
      popupStatus: status,
    });
  }

  handlePopupClose() {
    const status = {
      precisionLevel: false,
    };

    this.setState({
      popupStatus: status,
    });
  }

  handlePrecisionLevel = (e, string) => {
    const { currentPrecisionLevel } = this.state;
    const { handlePrecisionLevel } = this.props;
    const status = {
      precisionLevel: false,
    };

    this.setState({
      popupStatus: status,
    });
    if (string === currentPrecisionLevel) {
      return;
    }

    handlePrecisionLevel(string);
  };

  handlePageSizeChange(e, data) {
    const { pageSize } = this.state;
    if (pageSize === data.value) {
      return;
    }
    return this.props.handlePageSizeChange(data.value);
  }

  handleSortingChange(e, data) {
    const { sortColumn } = this.state;
    if (sortColumn === data.value) {
      return;
    }
    return this.props.onChangeSorting(data.value);
  }

  handleClickOutside(event) {
    const container = this.toggleBtnMenuRef.current;
    const rangeInput = this.dateRangeInputRef.current;

    if (rangeInput && rangeInput.contains(event.target)) {
      return;
    }

    if (event.target.closest('.ui.table')) {
      return;
    }

    if (container && !container.contains(event.target)) {
      this.setState({
        visible: false,
      });
    }
  }

  handleDateRange = (event, { name, value }) => {
    this.setState({ [name]: value });
  };

  handleRadioChange(e, { value }) {
    this.setState({
      radioValue: value,
    });
  }

  handleCheckChange(e, { value }) {
    const { checkValue } = this.state;
    let newState;
    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValue, value];
    }
    this.setState({
      checkValue: newState,
    });
  }

  handleCompareChange() {
    this.props.handleCompareChange();
  }

  handleAssignIssue() {
    this.props.handleAssignIssue();
  }

  handleChangeStatus() {
    this.props.handleChangeStatus();
  }

  handleDeleteChange = () => {
    this.props.handleDeleteChange();
  };

  handleStart = () => {
    this.setState({ isDragging: true });
  };

  handleStop = () => {
    this.setState({ isDragging: false });
  };

  onSubmit() {
    let uploadedStart;
    let uploadedEnd;

    const {
      rangeValue, checkValue, datesRange, radioValue
    } = this.state;
    const { location } = this.props;
    const pathname = location.pathname ? location.pathname : location;
    const [startDate, endDate] = datesRange.split(' - ');
    let assignedData;

    if (radioValue === 'udtime_cr') {
      uploadedStart = startDate;
      uploadedEnd = endDate;
    } else {
      uploadedStart = '';
      uploadedEnd = '';
    }

    this.setState({
      visible: false,
    });

    if (pathname.indexOf('overview') !== -1 || pathname.indexOf('component') !== -1) {
      assignedData = {
        component_min: rangeValue.min,
        component_max: rangeValue.max,
        uploaded_start: uploadedStart,
        uploaded_end: uploadedEnd,
        filter: checkValue,
        radio: radioValue,
      };
    } else {
      assignedData = {
        uploaded_start: uploadedStart,
        uploaded_end: uploadedEnd,
        filter: checkValue,
        radio: radioValue,
      };
    }
    this.props.onSubmit(assignedData);
  }

  getPrecisionLevel() {
    const { state, location } = this.props;
    const pathname = location.pathname ? location.pathname : location;
    const securityDetailRegex = /^\/results\/security\/[^/]+\/\d+$/;
    const licenseDetailRegex = /^\/results\/license\/[^/]+\/\d+$/;

    this.disposers.push(
      reaction(
        () => {
          if (pathname.indexOf('overview') !== -1 && pathname.indexOf('binary') !== -1) {
            const { currentPrecisionLevel, isUseCustomPrecisionLevelAllowed, isShowPrecisionLevelMenu } = toJS(state.company.detailSummary);
            const obj = {
              currentPrecisionLevel,
              isUseCustomPrecisionLevelAllowed,
              isShowPrecisionLevelMenu,
            };
            return obj;
          }
          if (pathname.indexOf('component') !== -1 && pathname.indexOf('binary') !== -1) {
            const { currentPrecisionLevel, isUseCustomPrecisionLevelAllowed, isShowPrecisionLevelMenu } = toJS(state.company.comDetailSummary);
            const obj = {
              currentPrecisionLevel,
              isUseCustomPrecisionLevelAllowed,
              isShowPrecisionLevelMenu,
            };
            return obj;
          }
          if (securityDetailRegex.test(pathname)) {
            const { currentPrecisionLevel, isUseCustomPrecisionLevelAllowed, isShowPrecisionLevelMenu } = toJS(state.company.secDetailSummary);
            const obj = {
              currentPrecisionLevel,
              isUseCustomPrecisionLevelAllowed,
              isShowPrecisionLevelMenu,
            };
            return obj;
          }
          if (licenseDetailRegex.test(pathname)) {
            const { currentPrecisionLevel, isUseCustomPrecisionLevelAllowed, isShowPrecisionLevelMenu } = toJS(state.company.licDetailSummary);
            const obj = {
              currentPrecisionLevel,
              isUseCustomPrecisionLevelAllowed,
              isShowPrecisionLevelMenu,
            };
            return obj;
          }
          if (pathname.indexOf('policy/project') !== -1) {
            const { currentPrecisionLevel, isUseCustomPrecisionLevelAllowed, isShowPrecisionLevelMenu } = toJS(state.company.policySumDetail);
            const obj = {
              currentPrecisionLevel,
              isUseCustomPrecisionLevelAllowed,
              isShowPrecisionLevelMenu,
            };
            return obj;
          }
        },
        (el) => {
          this.updatePrecisionLevel(el);
        }
      )
    );
  }

  generatePdfCallback = () => {
    this.props.generatePdfCallback();
  };

  createElementWithCanvas = () => {
    this.props.createElementWithCanvas();
  };

  removeCurrentFile = (string) => {
    this.props.removeCurrentFile(string);
  };

  changeStatusBtn = () => {
    const { translate } = this.props;
    const { isDisableStatus } = this.state;
    if (isDisableStatus) {
      return (
        <a
          className="gray_button util_button"
          style={{
            pointerEvents: 'none',
            cursor: 'default',
            opacity: '.45',
          }}
        >
          {translate('contents_header.menu.change_status')}
        </a>
      );
    }
    return (
      <a
        className="gray_button util_button"
        onClick={this.handleChangeStatus}
        style={{ cursor: 'pointer' }}
      >
        {translate('contents_header.menu.change_status')}
      </a>
    );
  };

  updatePrecisionLevel = (obj) => {
    const { state } = this.props;
    this.setState({
      currentPrecisionLevel: obj.currentPrecisionLevel,
      isShowPrecisionLevelMenu: obj.isShowPrecisionLevelMenu,
    }, () => {
      state.user.setCurrentConfidenceLevel(obj.currentPrecisionLevel);
    });
  };

  updateStateFromFilter = (filterArray) => {
    const newCheckValue = [];
    let newRadioValue = '';

    const radioPrefixes = ['udtime_', 'dttime_'];

    filterArray.forEach((item) => {
      const isRadio = radioPrefixes.some((prefix) => { return item.startsWith(prefix); });

      if (isRadio) {
        newRadioValue = item;
      } else {
        newCheckValue.push(item);
      }
    });

    this.setState({
      checkValue: newCheckValue,
      radioValue: newRadioValue,
    });
  };

  toggleViewMode = (e, value) => {
    if (value === 'list') {
      this.props.toggleViewMode('card');
    } else {
      this.props.toggleViewMode('list');
    }
  };

  toggleSelectMode = () => {
    const { isSelectable } = this.state;
    this.props.toggleSelectMode(!isSelectable);
  };

  toggleCheckChange = () => {
    this.props.toggleCheckChange();
  };

  toggleMenu() {
    const { visible } = this.state;
    this.setState({
      visible: !visible,
      isOpenCompare: false,
    });
  }

  clearSearch() {
    this.search.value = '';
    this.props.clearSearch();
  }

  closeMenu() {
    const {
      filter, radioValue, startDate, endDate, closeMenu
    } = this.props;
    let checkValue;

    if (filter) {
      checkValue = filter;
    } else {
      checkValue = [];
    }

    if (radioValue !== 'udtime_cr' && radioValue !== 'dttime_cr') {
      this.setState({
        visible: false,
        isOpenCompare: false,
        checkValue,
        radioValue,
      });
    } else {
      this.setState({
        visible: false,
        isOpenCompare: false,
        checkValue,
        radioValue,
        datesRange: `${startDate} - ${endDate}`
      });
    }
    if (closeMenu) {
      closeMenu();
    }
  }

  render() {
    const {
      radioValue,
      checkValue,
      errSearch,
      datesRange,
      viewMode,
      isCheckAll,
      isResizeHeaeder,
      refElement,
      isRendering,
      isRenderListOnly,
      isRenderProjectView,
      popupStatus,
      isOpenCompare,
      currentPrecisionLevel,
      isShowPrecisionLevelMenu,
      isDragging
    } = this.state;

    const {
      state,
      location,
      count,
      params,
      translate,
      useLeakage,
      selectedLeftData,
      selectedRightData,
      searchKeyword,
      totalCount,
    } = this.props;
    const pathname = location.pathname ? location.pathname : location;
    const precisionWithDetailPathRegex = /\/\d+$/;

    const tooltipStyle = {
      fontSize: '11px',
      fontWeight: '500',
    };

    let placeHolderName;

    const draggableStyle = (isDraggable) => {
      if (isDraggable) {
        return {
          cursor: 'move',
          willChange: 'transform',
          userSelect: 'none',
        };
      }
      return {
        cursor: 'move',
        willChange: 'auto',
      };
    };
    const sortColumn = currentSortColum(pathname, translate);

    const pageSizeList = [
      { key: 1, text: 10, value: 10 },
      { key: 2, text: 20, value: 20 },
      { key: 3, text: 40, value: 40 },
      { key: 4, text: 80, value: 80 },
    ];

    const renderApply = () => {
      if (radioValue === 'udtime_cr' || radioValue === 'dttime_cr') {
        if (radioValue === '') {
          return (
            <a className="apply_button" style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}>
              {translate('contents_header.button.apply')}
            </a>
          );
        }
        if (datesRange.split(' - ')[0] === '' || datesRange.split(' - ')[1] === '') {
          return (
            <a className="apply_button" style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}>
              {translate('contents_header.button.apply')}
            </a>
          );
        }
        return (
          <a className="apply_button" onClick={this.onSubmit}>
            {translate('contents_header.button.apply')}
          </a>
        );
      }
      return (
        <a className="apply_button" onClick={this.onSubmit}>
          {translate('contents_header.button.apply')}
        </a>
      );
    };

    if (pathname.indexOf('project') !== -1) {
      placeHolderName = `${translate('contents_header.place_holder.project')}, ${translate('contents_header.place_holder.version')}, ${translate('contents_header.place_holder.owner')}`;
    } if (pathname === '/results/overview' || pathname === '/results/overview/') {
      placeHolderName = `${translate('contents_header.place_holder.uploaded_file')}, ${translate('contents_header.place_holder.owner')}`;
    } if (pathname.indexOf('issue') !== -1) {
      placeHolderName = `${translate('contents_header.place_holder.uploaded_file')}`;
    } if (pathname.indexOf('results/overview/binary') !== -1) {
      placeHolderName = `${translate('contents_header.place_holder.scanned_file')}`;
    } if (pathname.indexOf('component') !== -1 && pathname.indexOf('project') === -1) {
      placeHolderName = `${translate('contents_header.place_holder.component')}`;
    } if (pathname.indexOf('security') !== -1 && pathname.indexOf('project') === -1) {
      placeHolderName = `${translate('contents_header.place_holder.security_risk')}`;
    } if (pathname.indexOf('license') !== -1 && pathname.indexOf('litigator') === -1 && pathname.indexOf('project') === -1) {
      placeHolderName = `${translate('contents_header.place_holder.license')}`;
    } if (pathname.indexOf('litigator') !== -1 && pathname.indexOf('license') !== -1 && pathname.indexOf('project') === -1) {
      placeHolderName = `${translate('contents_header.place_holder.litigator_code')}`;
    } if (pathname.indexOf('policy') !== -1 && pathname.indexOf('project') === -1) {
      placeHolderName = `${translate('contents_header.place_holder.policy_name')}`;
    }

    return (
      <div className="contents_header">
        <div className="contents_header_inner">
          <LinkHeader
            scannedFileCount={count}
            totalCount={totalCount}
            state={state}
            translate={translate}
          />
          <div className="util_wrap">
            {
              (pathname === '/results/overview/' || pathname === '/results/overview' || (pathname.indexOf('project') !== -1 && pathname.indexOf('policy/project') === -1))
              && (
                <div
                  className="util_item"
                >
                  <Draggable
                    onStart={this.handleStart}
                    onStop={this.handleStop}
                  >
                    <div
                      className={cx('compare_select', {
                        hide: !isOpenCompare,
                      })}
                      style={draggableStyle(isDragging)}
                    >
                      {/* hide className show or hide */}
                      <div className="compare_select_inner">
                        <div className="compare_select_header">
                          <h3 className="popup_title">{translate('contents_header.menu.compare_scan_results')}</h3>
                          <div className="button_wrap">
                            <a
                              className="cancel_button"
                              onClick={this.closeMenu}
                            >
                              {translate('contents_header.button.cancel')}
                            </a>
                            {
                              this.state.isSetLeft && this.state.isSetRight ? (
                                <a
                                  className="compare_button"
                                  onClick={this.handleCompareChange}
                                >
                                  {translate('contents_header.button.compare')}
                                </a>
                              ) : (
                                <a
                                  className="compare_button"
                                  style={{ pointerEvents: 'none', cursor: 'default', opacity: '.45' }}
                                >
                                  {translate('contents_header.button.compare')}
                                </a>
                              )
                            }
                          </div>
                        </div>
                        <div className="compare_contnet">
                          <div
                            className={cx('compare_item', {
                              select_file: this.state.isSetLeft,
                            })}
                          >
                            {
                              this.state.isSetLeft ? (
                                <div className="select_file_info">
                                  <p className="file_name">
                                    <span>{selectedLeftData.name}</span>
                                  </p>
                                  <p className="project_name">
                                    <span>{selectedLeftData.projectName}</span>
                                    <span>/</span>
                                    <span>{selectedLeftData.projectVersionName}</span>
                                  </p>
                                  <div className="select_file_info_bottom">
                                    <p className="date"><span>{selectedLeftData.uploadedDate}</span></p>
                                    <p className="owner_name"><span>{selectedLeftData.owner}</span></p>
                                  </div>
                                </div>
                              ) : (
                                <div className="file_drop_area">
                                  {
                                    viewMode === 'card' ? (
                                      <p className="text">
                                        {translate('contents_header.menu.drag_and_drop')}
                                        <br />
                                        {translate('contents_header.message.scan_results_header')}
                                      </p>
                                    ) : (
                                      <p className="text">
                                        {translate('contents_header.menu.select_the_file')}
                                        <br />
                                        {translate('contents_header.message.like_to_compare')}
                                      </p>
                                    )
                                  }
                                </div>
                              )
                            }
                          </div>
                          <Droppable droppableId="droppableRight">
                            {
                              (provided, snapshot) => {
                                return (
                                  <div
                                    className={cx('compare_item', {
                                      select_file: this.state.isSetRight,
                                    })}
                                    ref={provided.innerRef}
                                    style={{ backgroundColor: snapshot.isDraggingOver ? '#f5f4ff' : 'rgba(255, 255, 255, 0.8)' }}
                                    {...provided.droppableProps}
                                  >
                                    {
                                      this.state.isSetRight ? (
                                        <div className="select_file_info">
                                          <a
                                            className="file_remove_button"
                                            onClick={() => { return this.removeCurrentFile('right'); }}
                                          >
                                            <img src={closeBtn} alt="" />
                                          </a>
                                          <p className="file_name">
                                            <span>{selectedRightData.name}</span>
                                          </p>
                                          <p className="project_name">
                                            <span>{selectedRightData.projectName}</span>
                                            <span>/</span>
                                            <span>{selectedRightData.projectVersionName}</span>
                                          </p>
                                          <div className="select_file_info_bottom">
                                            <p className="date"><span>{selectedRightData.uploadedDate}</span></p>
                                            <p className="owner_name"><span>{selectedRightData.owner}</span></p>
                                          </div>
                                        </div>
                                      ) : (
                                        <div className="file_drop_area">
                                          {
                                            viewMode === 'card' ? (
                                              <p className="text">
                                                {translate('contents_header.menu.drag_and_drop')}
                                                <br />
                                                {translate('contents_header.message.scan_results_header')}
                                              </p>
                                            ) : (
                                              <p className="text">
                                                {translate('contents_header.menu.select_the_file')}
                                                <br />
                                                {translate('contents_header.message.like_to_compare')}
                                              </p>
                                            )
                                          }
                                        </div>
                                      )
                                    }
                                    {provided.placeholder}
                                  </div>
                                );
                              }
                            }
                          </Droppable>
                        </div>
                      </div>
                    </div>
                  </Draggable>
                </div>
              )
            }
            <div
              className={cx('util_item', {
                active: isResizeHeaeder,
              })}
            >
              {
                !isResizeHeaeder ? (
                  <div className="search_files_wrap">
                    <img src={searchIcon} alt="" className="icon" />
                    <input
                      type="search_files"
                      className="seach_text"
                      placeholder={placeHolderName}
                      ref={(ref) => {
                        this.search = ref;
                      }}
                      value={searchKeyword}
                      onChange={this.handleSearchChange}
                      onKeyPress={this.handleSearch}
                    />
                    <a className="reset_icon" onClick={this.clearSearch}>
                      x
                    </a>
                    {errSearch && (
                      <Label basic color="red" pointing>
                        {translate('contents_header.message.least_two_required_to_search')}
                      </Label>
                    )}
                  </div>
                ) : (
                  <div className="search_files_wrap" style={{ width: '175px' }}>
                    <img src={searchIcon} alt="" className="icon" />
                    <input
                      type="search_files"
                      className="seach_text"
                      style={{ width: '115px' }}
                      placeholder={placeHolderName}
                      ref={(ref) => {
                        this.search = ref;
                      }}
                      value={searchKeyword}
                      onChange={this.handleSearchChange}
                      onKeyPress={this.handleSearch}
                    />
                    <a className="reset_icon" onClick={this.clearSearch}>
                      x
                    </a>
                    {errSearch && (
                      <Label basic color="red" pointing>
                        {translate('contents_header.message.least_two_required_to_search')}
                      </Label>
                    )}
                  </div>
                )
              }
            </div>
            {
              (pathname !== `/results/license/litigator/${params.idReport}`)
              && (
                <div
                  className={cx('util_item common_filter_toggle_button', {
                    active: isResizeHeaeder,
                  })}
                >
                  <a
                    className="util_button icon_button"
                    onClick={this.toggleMenu}
                  >
                    <img src={filterIcon} alt="" />
                  </a>
                  <div
                    className={cx('common_filter', {
                      hide: !this.state.visible,
                    })}
                    ref={this.state.visible ? this.toggleBtnMenuRef : null}
                  >
                    <div className="common_filter_header">
                      <h2>{translate('contents_header.menu.filter_by')}</h2>
                    </div>
                    <CommonFilterList
                      checkValue={checkValue}
                      radioValue={radioValue}
                      datesRange={datesRange}
                      translate={translate}
                      useLeakage={useLeakage}
                      handleRadioChange={this.handleRadioChange}
                      handleCheckChange={this.handleCheckChange}
                      handleDateRange={this.handleDateRange}
                      ref={this.dateRangeInputRef}
                    />
                    <div className="common_filter_footer">
                      <a className="cancel_button" onClick={this.closeMenu}>
                        {translate('contents_header.button.cancel')}
                      </a>
                      {renderApply()}
                    </div>
                  </div>
                </div>
              )
            }
            {
              pathname.indexOf('issue') > -1
              && (
                <div
                  className={cx('button_wrap util_item', {
                    active: isResizeHeaeder,
                  })}
                >
                  <a
                    className="gray_button util_button"
                    onClick={this.handleAssignIssue}
                    style={{ cursor: 'pointer' }}
                  >
                    {translate('contents_header.menu.assign_issue')}
                  </a>
                  {this.changeStatusBtn()}
                </div>
              )
            }
            {
              pathname.indexOf('issue') === -1
              && (
                <ClarityReport
                  refElement={refElement}
                  isRendering={isRendering}
                  isRenderListOnly={isRenderListOnly}
                  isRenderProjectView={isRenderProjectView}
                  viewMode={viewMode}
                  translate={translate}
                  createElementWithCanvas={this.createElementWithCanvas}
                  generatePdfCallback={this.generatePdfCallback}
                />
              )
            }
            {
              (pathname.indexOf('project') !== -1 || (pathname.indexOf('overview') !== -1 && pathname.indexOf(params.idReport) === -1 && pathname.indexOf('issue') === -1))
              && (
                <div style={{ float: 'left' }}>
                  {
                    !isResizeHeaeder ? (
                      <div className="button_wrap util_item">
                        {
                          (this.state.isSelectable || viewMode === 'list')
                          && (
                            <a
                              className="check_button util_button"
                              style={{ cursor: 'pointer', marginRight: '5px' }}
                              onClick={this.toggleCheckChange}
                            >
                              {isCheckAll ? translate('contents_header.button.unselect_all') : translate('contents_header.button.select_all')}
                            </a>
                          )
                        }
                        {
                          (this.state.isSelectable || viewMode === 'list')
                          && (
                            <a
                              className="delete_button util_button"
                              style={{ cursor: 'pointer' }}
                              onClick={this.handleDeleteChange}
                            >
                              <span>
                                <img src={deleteIcon} alt="" style={{ width: '12px' }} />
                              </span>
                              {translate('contents_header.button.delete')}
                            </a>
                          )
                        }
                        {
                          viewMode === 'card'
                          && (
                            <a
                              className={cx('gray_button util_button', {
                                active: this.state.isSelectable,
                              })}
                              onClick={this.toggleSelectMode}
                              style={{ padding: '7px', verticalAlign: 'top' }}
                            >
                              {
                                this.state.isSelectable ? (
                                  <Icon name="checkmark" />
                                ) : (
                                  <Icon name="checkmark" />
                                )
                              }
                            </a>
                          )
                        }
                      </div>
                    ) : (
                      <div
                        className={cx('button_wrap util_item', {
                          active: isResizeHeaeder,
                        })}
                      >
                        {
                          (this.state.isSelectable || viewMode === 'list')
                          && (
                            <a
                              className="check_button util_button"
                              style={{
                                cursor: 'pointer', padding: '7px 10px', width: '28.5px', marginRight: '5px'
                              }}
                              onClick={this.toggleCheckChange}
                            >
                              {isCheckAll ? 'U' : 'S'}
                            </a>
                          )
                        }
                        {
                          (this.state.isSelectable || viewMode === 'list')
                          && (
                            <a
                              className="delete_button util_button"
                              style={{ cursor: 'pointer', padding: '7px 10px', width: '28.5px' }}
                              onClick={this.handleDeleteChange}
                            >
                              D
                            </a>
                          )
                        }
                        {
                          viewMode === 'card'
                          && (
                            <a
                              className={cx('gray_button util_button', {
                                active: this.state.isSelectable,
                              })}
                              style={{ padding: '7px', verticalAlign: 'top' }}
                              onClick={this.toggleSelectMode}
                            >
                              {
                                this.state.isSelectable ? (
                                  <Icon name="checkmark" />
                                ) : (
                                  <Icon name="checkmark" />
                                )
                              }
                            </a>
                          )
                        }
                      </div>
                    )
                  }
                </div>
              )
            }
            {
              !isResizeHeaeder ? (
                <div className="button_wrap util_item">
                  {
                    viewMode === 'card' ? (
                      <a
                        className="gray_button util_button"
                        style={{ cursor: 'pointer' }}
                        onClick={(e) => { return this.toggleViewMode(e, 'card'); }}
                      >
                        {
                          (
                            pathname.includes('binary')
                            || pathname.includes('issue')
                            || pathname.includes('results/component')
                            || pathname.includes('results/security')
                            || pathname.includes('results/license')
                            || pathname.includes('results/license/litigator')
                            || pathname.includes('results/policy')
                          )
                          && !pathname.endsWith('/project')
                            ? translate('contents_header.button.standard') : translate('contents_header.button.list_view')
                        }
                      </a>
                    ) : (
                      <a
                        className="gray_button util_button"
                        style={{ cursor: 'pointer' }}
                        onClick={(e) => { return this.toggleViewMode(e, 'list'); }}
                      >
                        {
                          (
                            pathname.includes('binary')
                            || pathname.includes('issue')
                            || pathname.includes('results/component')
                            || pathname.includes('results/security')
                            || pathname.includes('results/license')
                            || pathname.includes('results/license/litigator')
                            || pathname.includes('results/policy')
                          )
                          && !pathname.endsWith('/project')
                            ? translate('contents_header.button.infinite') : translate('contents_header.button.card_view')
                        }
                      </a>
                    )
                  }
                </div>
              ) : (
                <div
                  className={cx('button_wrap util_item', {
                    active: isResizeHeaeder,
                  })}
                >
                  {
                    viewMode === 'card' ? (
                      <a
                        className="gray_button util_button"
                        style={{ cursor: 'pointer', padding: '7px 10px', margin: '0 0 0 0' }}
                        onClick={(e) => { return this.toggleViewMode(e, 'card'); }}
                      >
                        {
                          (pathname.indexOf('binary') !== -1
                          || pathname.indexOf('issue') !== -1
                          || pathname.indexOf('results/component') !== -1
                          || pathname.indexOf('results/security') !== -1
                          || pathname.indexOf('results/license') !== -1
                          || pathname.indexOf('results/license/litigator') !== -1
                          || pathname.indexOf('results/policy') !== -1)
                          && pathname.indexOf('project') === -1
                            ? 'S' : 'L'
                        }
                      </a>
                    ) : (
                      <a
                        className="gray_button util_button"
                        style={{ cursor: 'pointer', padding: '7px 10px', margin: '0 0 0 0' }}
                        onClick={(e) => { return this.toggleViewMode(e, 'list'); }}
                      >
                        {
                          (pathname.indexOf('binary') !== -1
                          || pathname.indexOf('issue') !== -1
                          || pathname.indexOf('results/component') !== -1
                          || pathname.indexOf('results/security') !== -1
                          || pathname.indexOf('results/license') !== -1
                          || pathname.indexOf('results/license/litigator') !== -1
                          || pathname.indexOf('results/policy') !== -1)
                          && pathname.indexOf('project') === -1
                            ? 'I' : 'C'
                        }
                      </a>
                    )
                  }
                </div>
              )
            }
            {
              ((pathname.indexOf('project') !== -1 && pathname.indexOf('policy/project') === -1) || (pathname.indexOf('overview') !== -1 && pathname.indexOf(params.idReport) === -1 && pathname.indexOf('issue') === -1))
              && (
                <div
                  className={cx('util_item', {
                    active: isResizeHeaeder,
                  })}
                >
                  <Dropdown
                    className="contents_sorting"
                    selection
                    options={sortColumn}
                    value={this.state.sortColumn}
                    onChange={this.handleSortingChange}
                  />
                </div>
              )
            }
            <div
              className={cx('util_item', {
                active: isResizeHeaeder,
              })}
            >
              <Dropdown
                className="contents_sorting page_size"
                selection
                options={pageSizeList}
                value={this.state.pageSize}
                onChange={this.handlePageSizeChange}
              />
            </div>
            {
              precisionWithDetailPathRegex.test(pathname) && isShowPrecisionLevelMenu
              && (
                <div className="util_item">
                  <Popup
                    trigger={(
                      <a className="util_button more_button">
                        <img src={copyIcon} alt="" />
                      </a>
                    )}
                    on="click"
                    className="precision"
                    position="bottom left"
                    open={popupStatus.precisionLevel}
                    onOpen={this.handlePopupOpen}
                    onClose={this.handlePopupClose}
                  >
                    <Menu vertical>
                      <Menu.Header className="section_title">{translate('contents_header.menu.precision_level')}</Menu.Header>
                      <Popup
                        trigger={(
                          <Menu.Item
                            link
                            active={currentPrecisionLevel && currentPrecisionLevel === 'narrow'}
                            onClick={(e) => {
                              return this.handlePrecisionLevel(e, 'narrow');
                            }}
                          >
                            <Icon name="arrow alternate circle up" style={{ float: 'left', marginRight: '10px' }} color="green" />
                            {translate('contents_header.menu.narrow')}
                          </Menu.Item>
                        )}
                        content={translate('settings.message.narrow_level_display')}
                        inverted
                        position="bottom left"
                        style={tooltipStyle}
                      />
                      <Menu.Item
                        link
                        active={currentPrecisionLevel && currentPrecisionLevel === 'medium'}
                        onClick={(e) => {
                          return this.handlePrecisionLevel(e, 'medium');
                        }}
                      >
                        <Icon name="exchange" style={{ float: 'left', marginRight: '10px' }} color="blue" />
                        {translate('contents_header.menu.medium_precision')}
                      </Menu.Item>
                      <Popup
                        trigger={(
                          <Menu.Item
                            link
                            active={currentPrecisionLevel && currentPrecisionLevel === 'broad'}
                            onClick={(e) => {
                              return this.handlePrecisionLevel(e, 'broad');
                            }}
                          >
                            <Icon
                              name="arrow alternate circle down"
                              style={{ float: 'left', marginRight: '10px' }}
                              color="red"
                            />
                            {translate('contents_header.menu.broad')}
                          </Menu.Item>
                        )}
                        content={translate('settings.message.borad_level_display')}
                        inverted
                        position="bottom left"
                        style={tooltipStyle}
                      />
                    </Menu>
                  </Popup>
                </div>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}

export default ContentsHeaderWithResultAll;
